import React, { useEffect, useRef } from 'react';
import { classIf, getConfiguration } from '../../data/utils';
import { useUISettings, useUISettingsDispatch } from '../../UISettingsProvider';
import PrematchContext from '../../contexts/PrematchContext';

export default function ContentWrapper(props) {
    const conf = getConfiguration();
    const uiSettings = useUISettings();
    const dispatch = useUISettingsDispatch();
    const prematchContext = React.useContext(PrematchContext);

    const firstRender = useRef(true);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            dispatch({
                type: 'setFullscreen',
                isFullScreen: conf?.tfs === true || conf?.sctc === true || prematchContext.match?.openedFromBanner
            });
        }
    });

    return (
        <div className={"competizione-interna dueColonne dueColonne_Template_1" + classIf(uiSettings.fullScreen, 'unaColonna')}>
            <div id="primo-blocco-sport" className={"sport-blocco primo-blocco-sport go-up-arrow-on-overflow" + classIf(uiSettings.fullScreen, 'no-margin')}>
                {props.children[0]}
            </div>
            {props.children[1]}
        </div>
    );
}
